// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { IssueType, IssueTypeWithProjectId, State } from '../types.tsx';

export const addIssueTypes =
	(issueTypes: IssueTypeWithProjectId[]) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const issueTypesById = issueTypes.reduce<Record<string, IssueType | undefined>>(
			(acc, issueType) => {
				acc[issueType.id] = issueType;
				return acc;
			},
			{},
		);

		const issueTypesByProjectId = issueTypes.reduce<Record<string, string[] | undefined>>(
			(acc, issueType) => {
				const issueTypesForProject = acc[issueType.projectId];

				if (
					Array.isArray(issueTypesForProject) &&
					!acc[issueType.projectId]?.includes(issueType.id)
				) {
					acc[issueType.projectId] = [...issueTypesForProject, issueType.id];
				} else {
					acc[issueType.projectId] = [issueType.id];
				}

				return acc;
			},
			{},
		);

		const state = getState();

		setState({
			issueTypesById: {
				...state.issueTypesById,
				...issueTypesById,
			},
			issueTypesByProjectId: {
				...state.issueTypesByProjectId,
				...issueTypesByProjectId,
			},
		});
	};
